import pusher from '../pusher'
import { promotionImageButtonMapper } from '../mappers/promotion-image/promotion-image-button-mapper'

export function listenButtonEvents (event) {
  event.on('clickButton', (data) => {
    const mappedData = promotionImageButtonMapper(data)
    pusher.pushDataObject(mappedData)
  })
}
